import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeatureBlocks from './components/FeatureBlocks';
import Footer from './components/Footer'; // Import the Footer component
import './App.css';
import heroImage from './assets/hero.jpg'; // Import the image

const App = () => (
  <div>
    <div className="overlay"></div>
    <Router>
      <Header />
      <div className="hero-container">
        <div className="hero-image-wrapper">
          <img src={heroImage} alt="Futuristic Background" className="hero-image" />
        </div>
        <div className="hero-content">
          <HeroSection />
        </div>
      </div>
      <div className="content">
        <Routes>
          <Route path="/" element={<FeatureBlocks />} />
          {/* Add more routes as needed */}
        </Routes>
      </div>
      <Footer /> {/* Add the Footer component */}
    </Router>
  </div>
);

export default App;
